import React from 'react';
import Icon from '../../../components/AppIcon';

const PrioritySummaryCard = ({ title, count, icon, color, description }) => {
  const colorClasses = {
    red: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800 text-red-700 dark:text-red-300',
    amber: 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800 text-amber-700 dark:text-amber-300',
    blue: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-700 dark:text-blue-300',
    green: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-700 dark:text-green-300'
  };

  const iconColorClasses = {
    red: 'text-red-600 dark:text-red-400',
    amber: 'text-amber-600 dark:text-amber-400',
    blue: 'text-blue-600 dark:text-blue-400',
    green: 'text-green-600 dark:text-green-400'
  };

  return (
    <div className={`p-4 rounded-lg border ${colorClasses?.[color] || colorClasses?.blue}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium opacity-90">{title}</p>
          <p className="text-3xl font-bold mt-2">{count}</p>
          <p className="text-xs opacity-75 mt-1">{description}</p>
        </div>
        <div className={`p-3 rounded-lg bg-white dark:bg-slate-800 ${iconColorClasses?.[color] || iconColorClasses?.blue}`}>
          <Icon name={icon} size={24} />
        </div>
      </div>
    </div>
  );
};

export default PrioritySummaryCard;